/**
 * We'll load the axios HTTP library which allows us to easily issue requests
 * to our Laravel back-end. This library automatically handles sending the
 * CSRF token as a header based on the value of the "XSRF" token cookie.
 */

import Axios from 'axios'

window.axios = Axios

import sweetAlert from 'sweetalert2';
window.Swal = sweetAlert;

import $ from 'jquery';
window.$ = window.jQuery = $;

import JSZip from 'jszip';
window.JSZip = JSZip;

const myTimezone = new Date().toString().match(/([A-Z]+[\+-][0-9]+.*)/)[1];
window.myTimezone = myTimezone

window.axios.defaults.headers.common['X-Requested-With'] = 'XMLHttpRequest';

import ('popper.js')
import ('bootstrap')
import ('pdfmake')
import ('pdfmake/build/vfs_fonts')
import ('datatables.net-bs4')
import ('datatables.net-buttons-bs4')
import ('datatables.net-buttons/js/buttons.html5')
import ('datatables.net-buttons/js/buttons.print')

let token = document.head.querySelector('meta[name="csrf-token"]');
let baseUrl = document.head.querySelector('meta[name="base-url"]')?.content;
let bearerToken = document.head.querySelector('meta[name="api-token"]')?.content;

if (token) {
    window.axios.defaults.headers.common['X-CSRF-TOKEN'] = token.content;
} else {
    console.error('CSRF token not found: https://laravel.com/docs/csrf#csrf-x-csrf-token');
}
